<template>
  <div>
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes=pageSizes :page-size=pageSize layout="total, sizes, prev, pager, next, jumper" :total=originData.length></el-pagination>
    </div>
    <div v-show="false">{{getBindData}}</div>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  data() {
    return {
      currentPage: 1,
      pageSizes: [],
      pageSize: 0,
      currentCount: 0 // 记录当前理想状态下显示的数据条目，即this.pageSize*this.currentPage
    }
  },
  props: {
    originData: Array,
    pageSizesCount: Number // 定义pageSizes的数量
  },
  watch: {
    originData() {
      this.computedPageSize()
    }
  },
  mounted() {
    this.computedPageSize()
  },
  computed: {
    getBindData() {
      let start = this.pageSize * (this.currentPage - 1)
      let end = this.pageSize * this.currentPage
      let bindData = []
      for (let i = start; i < end; i++) {
        if (i >= this.originData.length) {
          break
        }
        bindData.push(this.originData[i])
      }
      // bindData=this.originData  //不分页
      this.$emit('getBindData', bindData)
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    getNum(num) {
      // 获取一个数字最近的10的倍数
      let count = 1
      while (count) {
        if (num < count * 10) {
          num = count * 10
          count = 0
        } else {
          count++
        }
      }
      return num
    },
    computedPageSize() {
      let total = this.originData.length
      if(this.pageSizesCount == -1){
        this.pageSizes=[total]
        this.pageSize = total
        return
      }
      let interval = Math.ceil(total / this.pageSizesCount)
      interval = this.getNum(interval)
      interval = 20
      this.pageSizes = []
      for (let i = 0; i < this.pageSizesCount; i++) {
        let num = interval * (i + 1)
        if (this.pageSizes.length < 5) {
          this.pageSizes.push(num)
        }
        if (num > total) {
          break
        }
      }
      this.pageSize = this.pageSizes[0]
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/pagination.vue